
import {initWebComponent} from "@/helpers/web-component-helper";
import {getToken} from "@/helpers/auth/auth-helper";
import {getFileByService} from "@/helpers/file-helper";

export class HeaderLogoComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');

        let style = this.getAttribute('date-style')
        if(!style) {
            style = 'height:35px;'
        }

        template.innerHTML = `
        <div class="d-flex justify-content-center">
            <img style="` + style + `" src="" data-test="header_logo_img">
        </div>
        `;

        initWebComponent(this, template)

        const url = `${window.kaartViewerUrl}/admin/v2/kaartviewerapi/bookmark/${window.websiteID}/logo`
        getFileByService(url).then(blob => {
            this.querySelector('img').src = URL.createObjectURL(blob)
        })
    }
}

